import createReducer from '../utils/createReducer';
import MapRecord from '../records/mapRecord';

const initialState = new MapRecord();

const actionHandlers = {};

export default createReducer(actionHandlers, initialState);
